import { parseTime } from '@/utils/util'
export const searchForm = {
  line_id: undefined,
  project: undefined,
  staff_style: undefined,
  type: undefined,
  keyword_fuzzy: undefined,
  created_at: []
}

export const form = {
  line_id: undefined, // 发布平台
  project: undefined,
  staff_style: undefined,
  type: undefined,
  keyword: '', // 关键词
  jump_link: '', // 跳转链接
}

export const rules = {
  line_id: [{ required: true, message: '请选择发布平台', trigger: 'change' }],
  keyword: [{ required: true, message: '请输入关键词', trigger: 'change' }],
  jump_link: [{ required: true, message: '请输入跳转链接', trigger: 'change' }],
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'project',
    width: 100,
    align: 'left',
    scopedSlots: { customRender: 'project' }
  },
  {
    title: '关键词',
    dataIndex: 'keyword',
    width: 200,
    align: 'left',
  },
  {
    title: '跳转链接',
    dataIndex: 'jump_link',
    align: 'left',
    width: 160,
  },
  {
    title: '创建人',
    dataIndex: 'createdUser',
    align: 'left',
    width: 160,
    scopedSlots: { customRender: 'createdUser' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: 160,
    align: 'left',
    customRender(text) {
      text === 0 ? text = '--' : text = parseTime(text)
      return text
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 160,
    scopedSlots: { customRender: 'operator' }
  }
]

// export const columnsArticle = [
//   {
//     title: '序号',
//     dataIndex: 'id',
//     width: 100,
//     align: 'center'
//   },
//   {
//     title: '标题',
//     dataIndex: 'article',
//     width: 160,
//     align: 'left',
//     scopedSlots: { customRender: 'title' }
//   },
//   {
//     title: '文章分类',
//     dataIndex: 'article.typeid',
//     width: 100,
//     align: 'left',
//     scopedSlots: { customRender: 'typeid' }
//   },
//   {
//     title: '发布时间',
//     dataIndex: 'article.created_at',
//     align: 'left',
//     width: 120,
//     customRender(text) {
//       return parseTime(text)
//     }
//   },
//   {
//     title: '发布人',
//     dataIndex: 'article.add_person_name',
//     width: 120,
//     align: 'left',
//     scopedSlots: { customRender: 'add_person_name' }
//   },
//   {
//     title: '操作',
//     dataIndex: 'operator',
//     align: 'center',
//     width: 50,
//     scopedSlots: { customRender: 'operator' }
//   }
// ]
